import React, { useRef } from "react";
import "./PaymentVoucherTemplate.css";
import html2pdf from "html2pdf.js";

// Helper function to convert numbers to words (simple version)
const numberToWords = (num) => {
  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  if (num === 0) return 'Zero';
  if (num < 20) return a[num];
  if (num < 100) return b[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + a[num % 10] : '');
  if (num < 1000) return a[Math.floor(num / 100)] + ' Hundred' + (num % 100 !== 0 ? ' ' + numberToWords(num % 100) : '');
  if (num < 1000000) return numberToWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 !== 0 ? ' ' + numberToWords(num % 1000) : '');
  return num; // For larger numbers, you can extend this
};

const PaymentVoucherTemplate = ({ voucher }) => {
  const voucherRef = useRef();

  const exampleVoucher = voucher || {
    id: 1,
    voucher_number: "PV-202603090001",
    sales_id: 101,
    payment_date: "2026-03-09",
    payment_method: "Cash",
    payer: "Rekonic Travel",
    payee: "John Doe",
    amount: 3000,
    tax_percentage: 5,
    tax_amount: 150,
    description: "Hotel booking payment",
    created_at: "2026-03-09T10:00:00",
    updated_at: "2026-03-09T10:00:00"
  };

  const handleDownloadPDF = () => {
    const element = voucherRef.current;
    const opt = {
      margin:       0.5,
      filename:     `PaymentVoucher_${exampleVoucher.voucher_number || exampleVoucher.id}.pdf`,
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
    html2pdf().from(element).set(opt).save();
  };

  return (
    <div>
      <button className="download-btn" onClick={handleDownloadPDF}>Download PDF</button>

      <div className="voucher-container" ref={voucherRef}>

        {/* HEADER */}
        <div className="receipt-header">
          <div className="logo-section">
            <img
              src={process.env.PUBLIC_URL + "/rekonic-logo.jpg"}
              alt="Rekonic Logo"
              className="logo"
            />
          </div>

          <div className="title-section">
            <h2>PAYMENT VOUCHER</h2>
          </div>

          <div className="voucher-info">
            <p><strong>Voucher No:</strong> {exampleVoucher.voucher_number || exampleVoucher.id}</p>
            <p><strong>Sales ID:</strong> {exampleVoucher.sales_id}</p>
            <p><strong>Date:</strong> {new Date(exampleVoucher.payment_date).toLocaleDateString()}</p>
          </div>
        </div>

        {/* Payer + Payee stacked */}
        <div className="payer-payee">
          <div className="payer-payee-box">
            <h4>Payer</h4>
            <p>{exampleVoucher.payer}</p>
            <h4>Payee</h4>
            <p>{exampleVoucher.payee || exampleVoucher.customer_name || exampleVoucher.supplier_name}</p>
          </div>
        </div>

        {/* Payment Details */}
        <table className="voucher-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Method</th>
              <th>Tax %</th>
              <th>Tax Amt</th>
              <th>Net Amount</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                {exampleVoucher.description || "Payment"}
                {exampleVoucher.bank_name && <><br/>Bank: {exampleVoucher.bank_name}</>}
                {exampleVoucher.cheque_number && <><br/>Cheque: {exampleVoucher.cheque_number} ({exampleVoucher.cheque_date})</>}
              </td>
              <td>{exampleVoucher.payment_method}</td>
              <td>{exampleVoucher.tax_percentage}%</td>
              <td>{Number(exampleVoucher.tax_amount).toFixed(2)}</td>
              <td>AED {Number(exampleVoucher.amount).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>

        {/* Summary */}
        <div className="summary-section">
  <p className="total-amount">
    Grand Total (AED) : {(Number(exampleVoucher.amount) + Number(exampleVoucher.tax_amount)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
  </p>
  <p className="amount-in-words">
    <em>Total Amount in words: {numberToWords(Number(exampleVoucher.amount) + Number(exampleVoucher.tax_amount))} Only</em>
  </p>
</div>

        {/* Footer */}
        <div className="voucher-footer">
          <div>
            <p><strong>Created At:</strong></p>
            <p>{new Date(exampleVoucher.created_at).toLocaleString()}</p>
          </div>

          <div>
            <p><strong>Last Updated:</strong></p>
            <p>{new Date(exampleVoucher.updated_at).toLocaleString()}</p>
          </div>
        </div>

        {/* Signature */}
        <div className="signature-section">
          <div className="signature-box">
            <p>Authorised Signature</p>
          </div>
          <img
            src={process.env.PUBLIC_URL + "/stamp.jpg"}
            alt="Stamp"
            className="stamp"
          />
        </div>

      </div>
    </div>
  );
};

export default PaymentVoucherTemplate;
